import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import {
  Button,
  Divider,
  Modal,
  Stack,
  TextInput,
  Text,
  Menu,
} from "@mantine/core";

import { Cubby } from "../../stores/Cubby";
import { MODALS } from "../../helpers/constants";
import { IconFileInvoice, IconKey } from "@tabler/icons-react";
import Keysend from "../keysend";
import { TextWithInfoAndIcon } from "../dataDisplay/textWithInfoAndIcon";
import { ARTICLES } from "../../docs/docsIndex";

const SendViaKeysendContainer = observer(({ cubby }: { cubby: Cubby }) => {
  const onClose = () => {
    cubby.setModal(null);
    cubby.handleKeysendPublicKeyChange("");
  };

  return (
    <>
      <Modal
        opened={cubby.currentModal == MODALS.SEND_VIA_KEYSEND}
        onClose={() => onClose()}
        title={
          <TextWithInfoAndIcon
            text="Keysend Payment"
            articleSlug={ARTICLES.SENDING_TO_KEYSEND.slug}
            icon={<IconKey size={24} />}
            cubby={cubby}
            textSize="lg"
          />
        }
      >
        <Keysend cubby={cubby} />
      </Modal>
    </>
  );
});

export default SendViaKeysendContainer;
